import React from 'react'

import Layout from '../components/layout'
import SEO from '../components/seo'
import MotionHelper from '../components/motionHelper/motionHelper';

// Styles
import '../layouts/styles/index.scss'

const IndexPage = () => (
  <Layout>
    <SEO
      title="Motion Lab"
      keywords={[`motionlab`, `cubic bezier`, `easing`, `react`]}
    />

    <MotionHelper />
  </Layout>
)

export default IndexPage
